/* src/app/components/doc-viewer-new/form-controls/option-button/option-button.component.scss */
.btn-group {
  display: inline-flex;
  align-items: center;
  position: relative;
  height: 48px;
  background-color: #40579E;
  border: 1px solid #40579E;
}
:host-context(.dark-theme) .btn-group {
  background-color: black;
  border: 1px solid rgba(0, 0, 0, 0.705);
}
.btn-group .btn {
  position: relative;
  z-index: 1;
}
.dropdown-menu {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}
:host-context(.dark-theme) .dropdown-menu {
  background-color: #2e2e2e;
}
.dropdown-menu.show {
  display: block;
}
.dropdown-item {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}
:host-context(.dark-theme) .dropdown-item {
  color: #fff;
}
.dropdown-item:hover {
  background-color: #f1f1f1;
}
:host-context(.dark-theme) .dropdown-item:hover {
  background-color: rgba(0, 0, 0, 0.32);
}
.btn-primary {
  background-color: inherit;
  box-shadow: inherit;
  color: white;
  border: none;
  height: 100%;
  cursor: pointer;
  transition: background-color 0.3s ease-out;
}
.btn-primary:hover {
  background-color: rgb(36, 62, 144);
}
:host-context(.dark-theme) .btn-primary:hover {
  background-color: #2E2E2E;
}
.dropdown-toggle {
  cursor: pointer;
  width: 55px;
  border-left: rgba(237, 237, 237, 0.2392156863) 1px solid;
}
.dropdown-toggle-icon {
  opacity: 0.5;
  transition: opacity 550ms ease-out, transform 500ms ease-out;
}
:host-context(.dark-theme) .dropdown-toggle-icon {
  color: rgb(255, 193, 7);
}
.dropdown-toggle:hover .dropdown-toggle-icon {
  opacity: 1;
  transform: scale(1.1);
}
.dropdown-toggle::after {
  margin-left: 0.5em;
}
.disabled {
  cursor: default !important;
  background: rgba(0, 0, 0, 0.12);
  --fa-primary-color: rgb(117 134 188);
  --fa-secondary-color: rgb(65 87 156);
  color: #7384b9;
}
:host-context(.dark-theme) .disabled {
  --fa-primary-color: #6d6d6d;
  --fa-secondary-color: #6d6d6d;
  color: rgba(132, 132, 132, 0.7098039216);
  background-color: #434343;
}
.disabled:hover {
  background: rgba(0, 0, 0, 0.12);
  --fa-primary-color: rgb(117 134 188);
  --fa-secondary-color: rgb(65 87 156);
  color: #7384b9;
}
:host-context(.dark-theme) .disabled:hover {
  --fa-primary-color: #6d6d6d;
  --fa-secondary-color: #6d6d6d;
  color: rgba(132, 132, 132, 0.7098039216);
  background-color: #434343;
}
.icon {
  --fa-primary-color: rgb(36, 62, 144);
  --fa-secondary-color: #a6b1d2;
  --fa-secondary-opacity: 1;
}
:host-context(.dark-theme) .icon {
  --fa-primary-color: #FFC107;
  --fa-secondary-color: #454545;
}
.disabled-icon {
  --fa-primary-color: rgb(117 134 188);
  --fa-secondary-color: rgb(65 87 156);
}
:host-context(.dark-theme) .disabled-icon {
  --fa-primary-color: #6d6d6d;
  --fa-secondary-color: #6d6d6d;
  color: inherit;
}
/*# sourceMappingURL=option-button.component.css.map */
